import React from "react";
import { ActionTypes } from "../../action-type";
import secureLocalStorage from "react-secure-storage";
import axiosInstance from "../../../services/axios";
import axios from "axios";

export const getCounterStatement = (values)=>async(dispatch)=>{
    try{
        const response = await axiosInstance.get("/action/counter",{params:{virtual_id:values.virtual_id,team:values.team}});
        const {data} = response;
    }   
    catch (err){
        throw(err)
    }
}

export const updateCounterStatement = (values)=>async(dispatch)=>{
    try{
        const response = await axiosInstance.put("/action/counter",values);
        const {data} = response;
    }
    catch (err){
        throw(err)
    }
}